export class CreateCaracteristicaPropiedadRequest {

    public id_Propiedad: number = 0;
    public id_CaracteristicaPropiedad: number = 0;
    public cantidad: number = 0;
}